const colorList = ['#92bc5d', '#7bcbed', '#e392ff'];
const accentColor = colorList[Math.floor(Math.random() * colorList.length)];

module.exports = {
  white: '#ffffff',
  offWhite: '#f9f9f9',
  grey: '#494949',
  accent: accentColor,
  textPrimary: '#0e0e0e',
  textSecondary: '#232323',
  textPrimaryLight: '#f9f9f9',

  twitterLink: 'https://twitter.com/TranslucentLeaf',
  githubLink: 'https://github.com/tomdng',
  instaLink: 'https://www.instagram.com/tom_dong/',

  maxContentWidth: '1500px',
  maxTextWidth: '700px',
};
